import {
  useLanguage, LanguageProvider, LanguageRouting, useLanguageValue,
} from '@ipc/routing';

export {
  LanguageProvider, LanguageRouting, useLanguage, useLanguageValue,
};
